import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServiceProviderHub, SingleResponse} from '@generated-backend-types';
import {Observable} from 'rxjs';
import AuthenticatedContact = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Auth.AuthenticatedContact;
import ServiceProviderHubRegistrationData = ServiceProviderHub.App.Data.ServiceProviderHub.Auth.ServiceProviderHubRegistrationData;

@Injectable({providedIn: 'root'})
export class AuthService {
  private readonly http = inject(HttpClient);

  private readonly endpoint: string = '/auth';

  public login(email: string, password: string): Observable<SingleResponse<AuthenticatedContact>> {
    return this.http.post<SingleResponse<AuthenticatedContact>>(this.endpoint + '/login', {
      email,
      password
    });
  }

  public logout(): Observable<void> {
    return this.http.post<void>(this.endpoint + '/logout', {});
  }

  public register(data: ServiceProviderHubRegistrationData): Observable<void> {
    return this.http.post<void>(this.endpoint + '/registration', data);
  }

  public forgotPassword(email: string): Observable<void> {
    return this.http.post<void>(this.endpoint + '/forgot-password', {email});
  }

  public resetPassword(token: string, email: string, password: string, password_confirmation: string): Observable<void> {
    return this.http.post<void>(this.endpoint + '/reset-password', {token, email, password, password_confirmation});
  }

  public getAuthenticatedUser(): Observable<SingleResponse<AuthenticatedContact>> {
    return this.http.get<SingleResponse<AuthenticatedContact>>(this.endpoint + '/user');
  }
}
